import React from 'react'
import styled from 'styled-components'

import theme from '@app/ui/theme'

interface ArrowDownIconProps {
  color?: string
  className?: string
  onClick?: () => void
  inversedVertical?: boolean
}

const StyledSVG = styled.svg<{ inversedVertical?: boolean }>`
  margin-top: -0.2rem;
  transition: all 200ms;
  ${({ inversedVertical }) => inversedVertical && 'transform: rotate(180deg); margin-top: 0.5rem;'}
`

const ArrowDownIcon = ({
  color = theme.global.colors.genoa,
  className,
  onClick,
  inversedVertical
}: ArrowDownIconProps) => {
  return (
    <StyledSVG
      inversedVertical={inversedVertical}
      className={className}
      onClick={onClick}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.35355 5.35355C9.54882 5.15829 9.54882 4.84171 9.35355 4.64645C9.15829 4.45118 8.84171 4.45118 8.64645 4.64645L9.35355 5.35355ZM5.00012 8.99988L4.64657 9.35343C4.84183 9.54869 5.15841 9.54869 5.35368 9.35343L5.00012 8.99988ZM1.3538 4.64645C1.15854 4.45118 0.841953 4.45118 0.646691 4.64645C0.451429 4.84171 0.451429 5.15829 0.646691 5.35355L1.3538 4.64645ZM8.64645 4.64645L4.64657 8.64632L5.35368 9.35343L9.35355 5.35355L8.64645 4.64645ZM5.35368 8.64632L1.3538 4.64645L0.646691 5.35355L4.64657 9.35343L5.35368 8.64632Z"
        fill={color}
      />
    </StyledSVG>
  )
}

export default ArrowDownIcon
